import {logger} from './logger';

function catchImportError(name: string) {
    logger.error(`Unable to load "${name}" plugin`);
    return null;
}

export const lazyModules = {
    xlsx: async () => {
        try {
            return await import('xlsx');
        } catch {
            catchImportError('xlsx');
        }
    },
    reactGoogleCharts: async () => {
        try {
            return await import('react-google-charts');
        } catch {
            catchImportError('react-google-charts');
        }
    }
};